module.exports = __webpack_public_path__ + "static/media/card-logo-3.c3093ad5.svg";